/**
 * Informational text about the remaining items.
 *
 * @param {object} props
 * @param {number} props.expectedRemainingUnits - The number of expected remaining units.
 * @param {number} props.unitsPerCase - The number of units per case.
 * @returns {JSX.Element}
 */
function Step2_RemainingItemsInfo({ expectedRemainingUnits, unitsPerCase }) {
    return (
        <div className="px-3 py-2 bg-amber-50 rounded-lg">
            <div className="space-y-1">
                <h3 className="text-xs text-amber-700 font-semibold">Remaining Items:</h3>
                <p className="text-xs text-amber-700">
                    If there are remaining cases/units at original location after transfer, list them here. If no
                    cases/units remain, enter '0' for both fields.
                </p>
                <p className="text-xs mt-1">
                    Expected Remaining Units: <span className="font-semibold">{expectedRemainingUnits}</span>
                </p>
                <p className="text-xs text-amber-700">
                    Note: Remaining cases will use the original units per case ({unitsPerCase || 0}) for calculations.
                </p>
            </div>
        </div>
    );
}

export default Step2_RemainingItemsInfo;
